<mat-toolbar class="header-toolbar" [class.mobile]="isMobile">
  <!-- Menu Button (for both mobile and desktop sidebar toggle) -->
  @if (isMobile) {
    <button
      mat-icon-button
      class="menu-toggle-button"
      (click)="onToggleSidebar()"
      [attr.aria-label]="isMobile ? 'Toggle mobile menu' : 'Toggle sidebar'"
    >
      <mat-icon>menu</mat-icon>
    </button>
  }

  <!-- Logo/Brand -->
  <div
    class="logo-container"
    [class.mobile]="isMobile"
    (click)="onToggleSidebar()"
  >
    <img
      src="../../../assets/icons/cat-logo.png"
      [width]="50"
      alt="cat-logo"
      class="logo-image"
    />
    <h3 class="logo-text" [class.hidden-mobile]="isMobile">
      {{ "layout.appName" | translate }}
    </h3>
  </div>

  <!-- Spacer -->
  <span class="spacer"></span>

  <!-- Right Side Actions -->
  <div class="header-actions" [class.mobile]="isMobile">
    <!-- User Type - Hidden on mobile -->
    @if (!isMobile) {
      <div class="user-info-block">
        <span class="user-type">{{ userName }}</span>
        @if (profile?.role) {
          <span class="user-role">{{ profile?.role }}</span>
        }
      </div>
    }

    <!-- Notifications -->
    <button
      mat-icon-button
      [matMenuTriggerFor]="notificationMenu"
      class="notification-button"
      [attr.aria-label]="'Notifications (' + notificationCount + ' unread)'"
      [hidden]="true"
    >
      <mat-icon
        [matBadge]="notificationCount"
        [matBadgeHidden]="notificationCount === 0"
        matBadgeColor="warn"
        matBadgeSize="small"
        aria-hidden="false"
      >
        notifications
      </mat-icon>
    </button>

    <!-- User Profile Menu -->
    @if (isMobile) {
      <button
        mat-icon-button
        [matMenuTriggerFor]="userMenu"
        class="user-menu-button"
        aria-label="User menu"
      >
        <mat-icon>account_circle</mat-icon>
      </button>
    }

    <!-- Desktop Logout Button -->
    @if (!isMobile) {
      <button
        type="button"
        class="logout-btn cat-y-btn"
        mat-raised-button
        color="primary"
        (click)="logout()"
      >
        <span>{{ "layout.logout" | translate }}</span>
      </button>
    }
  </div>
</mat-toolbar>

<!-- Notification Menu -->
<mat-menu #notificationMenu="matMenu" class="notification-menu">
  <div class="notification-header" mat-menu-item [disabled]="true">
    <span class="notification-title">{{
      "layout.notifications.title" | translate
    }}</span>
    <button
      mat-button
      color="primary"
      size="small"
      (click)="markAllAsRead(); $event.stopPropagation()"
      [disabled]="notificationCount === 0"
    >
      {{ "layout.notifications.markAllAsRead" | translate }}
    </button>
  </div>
  <mat-divider></mat-divider>

  @if (notifications.length > 0) {
    <div class="notification-list">
      @for (notification of notifications.slice(0, 5); track notification.id) {
        <button
          mat-menu-item
          (click)="handleNotificationClick(notification)"
          class="notification-item"
          [class.unread]="!notification.isRead"
        >
          <mat-icon
            [color]="notification.isRead ? 'primary' : 'warn'"
            class="notification-icon"
          >
            {{ getNotificationIcon(notification) }}
          </mat-icon>
          <div class="notification-content">
            <span class="notification-text">{{ notification.subject }}</span>
            <span class="notification-time">{{
              formatNotificationTime(
                notification.createdDate || notification.date
              )
            }}</span>
          </div>
        </button>
      }
    </div>
  }

  @if (notifications.length === 0) {
    <div class="no-notifications" mat-menu-item [disabled]="true">
      <mat-icon>notifications_none</mat-icon>
      <span>{{ "layout.notifications.noNotifications" | translate }}</span>
    </div>
  }

  <mat-divider></mat-divider>
  <button
    mat-menu-item
    (click)="viewAllNotifications()"
    class="view-all-button"
  >
    <mat-icon>view_list</mat-icon>
    <span>{{ "layout.notifications.viewAll" | translate }}</span>
  </button>
</mat-menu>

<!-- Mobile User Menu -->
<mat-menu #userMenu="matMenu" class="user-menu">
  <div class="user-info" mat-menu-item [disabled]="true">
    <mat-icon>account_circle</mat-icon>
    <div class="user-details">
      <span class="user-name">{{ "layout.systemUser" | translate }}</span>
      <span class="user-role">{{ "layout.administrator" | translate }}</span>
    </div>
  </div>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="navigateTo('/profile')">
    <mat-icon>person</mat-icon>
    <span>{{ "layout.profile" | translate }}</span>
  </button>
  <button mat-menu-item (click)="navigateTo('/settings')">
    <mat-icon>settings</mat-icon>
    <span>{{ "layout.settings" | translate }}</span>
  </button>
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="logout()" class="logout-menu-item">
    <mat-icon>logout</mat-icon>
    <span>{{ "layout.logout" | translate }}</span>
  </button>
</mat-menu>
